import React, { FocusEvent } from "react";
import { ActionHandlerFunction } from "@preveil-api";
import { AdminUIActionTypes, CheckboxStates, DataExportAllContent, AdminInfoMessages } from "src/common";
import { Checkbox, Icon } from "src/components";
import _ from "lodash";

type AllProps = {
    content: DataExportAllContent;
    handleAction: ActionHandlerFunction;
};

// Description: Display the content of the data export request in a table (get started page)
function ExportContentCollapseComponent(props: AllProps) {
    const { content, handleAction } = props;
    const { mail, drive, logs, acl_report, include_all_versions } = content;
    const content_list = ["mail", "drive", "include_all_versions", "logs", "acl_report"];

    return <div className="data-export-content-table">
        {_.map(content_list, (type: string, index: number) => {
            const property = type === "mail" ? mail : type === "drive" ? drive : type === "include_all_versions" ? include_all_versions : type === "logs" ? logs : acl_report;
            const _name = type ==="acl_report" ? "ACL Report" : type === "include_all_versions" ? "Extract all document history" : _.capitalize(type);

            if (type === "include_all_versions" && !drive) {
                return null;
            }

            return (
                <div className="data-export-content-row" key={index}>
                    <Checkbox
                        className="sr-only"
                        value="type"
                        selected={property ? CheckboxStates.checked : CheckboxStates.empty}
                        onChange={(e: FocusEvent<HTMLInputElement>) => handleAction({ actionType: AdminUIActionTypes.SelectDataExportContent, params: { e, id: type } })}
                    />
                    <label>{_name}</label>
                    {type === "include_all_versions" && (
                        <Icon
                            tooltip={AdminInfoMessages.drive_documents_version}
                            className="pv-icon-info"
                        />
                    )}
                </div>
            );
        })}
    </div>;
}

export default React.memo(ExportContentCollapseComponent);